import { defineMessages } from 'react-intl';

export default defineMessages({
  charactersCounter: {
    id: 'app.components.Form.textarea.charactersCounter',
    defaultMessage: '{currentCount} / {maxCharacters} characters',
  },
});
